module.exports = __webpack_public_path__ + "static/media/apple.e2af1765.svg";